// Function to toggle the visibility of filters (News or Events) on mobile
function toggleFilters(filterType) {
  const filterButton = document.querySelector('.filter__button');
  const filterForm = document.querySelector('.sidebar-filters form');
  const breakpoint = 880;

  if (!filterButton || !filterForm) return;

  function updateFilterForm() {
    if (window.innerWidth < breakpoint) {
      filterForm.style.display = 'none';
      filterButton.style.display = 'flex';
    } else {
      filterForm.style.display = 'flex';
      filterButton.style.display = 'none';
    }
  }

  // Event listener for button click to toggle form visibility on mobile
  filterButton.addEventListener('click', () => {
    if (window.innerWidth < breakpoint) {
      if (filterForm.style.display === 'none') {
        filterForm.style.display = 'flex';
        filterForm.classList.add('active');
      } else {
        filterForm.style.display = 'none';
        filterForm.classList.remove('active');
      }
    }
  });

  // Event listener for window resize to adjust visibility
  window.addEventListener('resize', updateFilterForm);
  updateFilterForm();
}

// Initialize the toggle functionality for both News and Events after the DOM loads
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.listing-container')) {
    toggleFilters();
  }
});
